import {
  Button, Card, Radios,
} from 'nhsuk-react-components';
import Back from 'components/Back';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getTeamIdFromRole, getWriteRoles } from 'utils/userUtils';
import useUser from 'hooks/useUser';
import { useState } from 'react';
import useFetchCampaignTemplatesForTeam from 'queries/fetch/fetchCampaignTemplatesForTeam.ts';
import featureFlags from 'services/featureFlags.ts';
import TeamRadioItem from 'components/TeamRadioItem';

function SelectTeamPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { roles } = useUser();

  const writeRoles = getWriteRoles(roles);
  const teamIds = writeRoles.map(getTeamIdFromRole);

  const [selectedTeam, setSelectedTeam] = useState('');
  const [noTeamIdSelected, setNoTeamIdSelected] = useState(false);

  const teamCampaignTemplates = useFetchCampaignTemplatesForTeam({ teamId: selectedTeam });

  const handleSubmit = async () => {
    if (!selectedTeam) {
      setNoTeamIdSelected(true);
      return;
    }

    if (teamCampaignTemplates.isFetching) {
      // Should not happen, the button is disabled when fetching.
      return;
    }

    if (featureFlags.campaignTemplates && searchParams.has('template')) {
      navigate(`/${selectedTeam}/campaign/new/template-selection`);
      return;
    }

    navigate(`/${selectedTeam}/campaign/new/key-details`);
  };

  return (
    <>
      <div className="nhsuk-u-margin-bottom-6">
        <Back label="Manage campaigns" backTo="/campaigns" />
      </div>

      <Card>
        <main
          id="maincontent"
          className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
        >
          Create a campaign for a team
        </main>
      </Card>

      <Card>
        <div className="form-field-group nhsuk-u-margin-bottom-2">

          <Radios
            legend="Choose a team"
            legendProps={{
              size: 'm',
            }}
            name="team-selection"
            onChange={(e) => {
              setNoTeamIdSelected(false);
              setSelectedTeam((e.target as HTMLInputElement).value);
            }}
            error={
                noTeamIdSelected ? 'Choose a team to continue' : undefined
              }
          >
            {teamIds.map((teamId) => (
              <TeamRadioItem key={teamId} teamId={teamId} />
            ))}
          </Radios>
        </div>
      </Card>

      <Button onClick={handleSubmit} disabled={teamCampaignTemplates.isFetching}>
        Continue
      </Button>
    </>
  );
}

export default SelectTeamPage;
